import { useContext } from 'preact/hooks';
import { downcastRef } from '../../util/typing';
import CloseableContext from '../CloseableContext';
import { CancelIcon } from '../icons';
import IconButton from './IconButton';
import { jsx as _jsx } from "preact/jsx-runtime";
/**
 * Render a close button. Use provided `onClick` or check for a CloseableContext
 * with a close handler.
 */
export default function CloseButton({
  children,
  classes,
  elementRef,
  title,
  onClick,
  ...iconButtonProps
}) {
  var _ref;
  const closeableContext = useContext(CloseableContext);
  // Provided `title` and `onClick` are prioritized, but fall back to values
  // from the `CloseableContext`
  const buttonTitle = (_ref = title !== null && title !== void 0 ? title : closeableContext === null || closeableContext === void 0 ? void 0 : closeableContext.title) !== null && _ref !== void 0 ? _ref : 'Close';
  const closeHandler = onClick !== null && onClick !== void 0 ? onClick : closeableContext === null || closeableContext === void 0 ? void 0 : closeableContext.onClose;
  return _jsx(IconButton, {
    "data-component": "CloseButton",
    elementRef: downcastRef(elementRef),
    icon: CancelIcon,
    title: buttonTitle,
    classes: classes,
    ...iconButtonProps,
    onClick: closeHandler,
    children: children
  });
}
//# sourceMappingURL=CloseButton.js.map